import { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "./Shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TrialSection() {
  const [starting, setStarting] = useState(false);

  const start = async () => {
    if (starting) return;
    setStarting(true);
    try {
      const { data } = await axios.post(`${API}/billing/checkout`, {
        email: "",
        plan_key: "trial",
        credit_quantity: 1,
      });
      if (!data?.checkout_url) throw new Error("no checkout url");
      window.location.assign(data.checkout_url);
    } catch (err) {
      setStarting(false);
      toast.error(err?.response?.data?.detail || "Could not start your checkout — please try again.");
    }
  };

  return (
    <section id="trial" data-testid="trial-section" className="relative">
      <div className="mx-auto max-w-4xl px-6 py-16 sm:py-20">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-amber-400/40 bg-gradient-to-b from-[#1A1408]/70 to-[#070B14]/90 p-9 text-center sm:p-14">
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-0"
              style={{ background: "radial-gradient(circle at 50% -40%, rgba(245,158,11,0.18), transparent 60%)" }}
            />
            <div className="relative">
              <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-amber-300">
                No subscription · No commitment
              </p>
              <h2
                data-testid="trial-headline"
                className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl"
              >
                Try Us for $1
              </h2>
              <p
                data-testid="trial-subheadline"
                className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-300"
              >
                Get your first custom Etsy design for one dollar. No subscription. No commitment. Send
                us a real brief and judge the finished artwork yourself.
              </p>
              <button
                data-testid="trial-cta-button"
                onClick={start}
                disabled={starting}
                className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-amber-400 px-9 py-4 text-base font-bold text-[#1A1204] transition-all duration-300 hover:-translate-y-0.5 hover:bg-amber-300 hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] disabled:cursor-not-allowed disabled:opacity-60"
              >
                {starting ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />}
                {starting ? "Opening checkout..." : "Get My $1 Design"}
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}